<template>
  <div>
    <EditOrCreateRuleModal
      :rule="currentRule"
      :isVisible="openModal"
      :carrier="carrier"
      :isNewRule="isNewRule"
      ruleType="tracking"
      @close="closeModal"
      @update="update"
    /><RuleShortSettingsModal
      ruleType="tracking"
      :id="idRule"
      :isVisible="openConfigModal"
      @close="closeConfigModal"
    />
    <el-card class="box-card">
      <div slot="header" style="text-align: right;" >
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="addRule">
          Agregar
        </el-button>
      </div>
      <div>
        <Table
          ref="tableComponent"
          ruleType="tracking"
          :showConfigBtn="true"
          @edit="edit"
          @clickConfiguration="openConfigurationModal"
        />
      </div>
      <PublishRules
        ruleType="tracking"
      />
    </el-card>
  </div>
</template>
<script>
import Table from '../components/Table.vue';
import EditOrCreateRuleModal from '../components/EditOrCreateRuleModal.vue';
import PublishRules from '../components/PublishRules.vue';
import RuleShortSettingsModal from '../components/RuleShortSettingsModal.vue';
import store from '../observables/carrier';

export default {
  name: 'Tracking',
  components: {
    Table,
    EditOrCreateRuleModal,
    PublishRules,
    RuleShortSettingsModal,
  },
  data() {
    return {
      openModal: false,
      currentRule: null,
      isNewRule: false,
      idRule: '',
      openConfigModal: false,
    };
  },
  computed: {
    carrier() {
      return store.carrier;
    },
  },
  methods: {
    edit(item) {
      this.currentRule = item;
      this.isNewRule = false;
      this.openModal = !this.openModal;
    },
    closeModal() {
      this.openModal = false;
    },
    update() {
      this.$refs.tableComponent.getTracking();
      this.closeModal();
    },
    addRule() {
      this.currentRule = null;
      this.isNewRule = true;
      this.openModal = true;
    },
    openConfigurationModal(id) {
      this.idRule = id;
      this.openConfigModal = true;
    },
    closeConfigModal() {
      this.openConfigModal = false;
    },
  },
};
</script>
